import React from "react";

function ShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      fill="none"
      viewBox="0 0 16 18"
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.047"
        d="M11.187 12.915l.016.009.013-.013A2.467 2.467 0 0113 12.149a2.477 2.477 0 11-2.393 1.84l.004-.017-.015-.01-5.782-3.252-.016-.009-.012.013a2.477 2.477 0 110-3.428l.012.013.016-.009 5.782-3.253.015-.009-.004-.017a2.469 2.469 0 11.608 1.078l-.012-.013-.016.01-5.781 3.252-.016.009.005.017c.11.417.11.855 0 1.272l-.005.017.016.01 5.781 3.252z"
      ></path>
    </svg>
  );
}

export default ShareIcon;
